import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'

const TOKEN_DATA = [
  {
    imagePath: '/images/token-images (1).png',
    name: 'Lorem Ipsum',
    description: `Lorem Ipsum is simply dummy te printing & typesetting industry
                has been the.`,
  },
  {
    imagePath: '/images/token-images (2).png',
    name: 'Lorem Ipsum',
    description: `Lorem Ipsum is simply dummy te printing & typesetting industry
                has been the.`,
  },
  {
    imagePath: '/images/token-images (3).png',
    name: 'Lorem Ipsum',
    description: `Lorem Ipsum is simply dummy te printing & typesetting industry
                has been the.`,
  },
]

export default function Token() {
  return (
    <div
      className='bg-[#27D6900D] md:mt-20 mt-10 md:pt-44 md:pb-20 pt-10 pb-10 relative right-0'
      id='token'
    >
      <img
        src='/images/Ellipse.png'
        alt='Ellipse'
        className='absolute -z-40 top-0'
      />
      <div className='container mx-auto md:px-10 px-5 relative'>
        <AnimateOnScroll animation='flipIn'>
          <p className='text-[#545454] text-xl  font-medium text-center'>
            Token Metrics
          </p>
        </AnimateOnScroll>
        <AnimateOnScroll animation='flipIn'>
          <h3 className='font-medium text-[40px] text-[#0E0339] text-center'>
            YieldStone Token Distribution
          </h3>
        </AnimateOnScroll>

        <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10 mt-10'>
          {TOKEN_DATA.map((item, indx) => (
            <AnimateOnScroll
              animation='flipIn'
              key={indx}
            >
              <div className='bg-white rounded-3xl p-[50px] '>
                <AnimateOnScroll animation='flipIn'>
                  <img
                    src={item.imagePath}
                    alt={item.name}
                    width={80}
                    height={80}
                  />
                </AnimateOnScroll>
                <AnimateOnScroll animation='flipIn'>
                  <h3 className='font-medium text-xl text-[#0E0339] my-5'>
                    {item.name}
                  </h3>
                </AnimateOnScroll>
                <AnimateOnScroll animation='flipIn'>
                  <p className='text-[#545454]   font-light '>
                    {item.description}
                  </p>
                </AnimateOnScroll>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </div>
  )
}
